import { createTheme } from "@mui/material/styles";
import { BRAND } from "./styles/brand";

/**
 * MUI side of the shared color scheme (ENB-565). Without this every MUI component
 * fell back to MUI's default blue, which is why the MUI pages never matched the
 * Bulma pages or the dashboard.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: BRAND.primary,
      light: BRAND.primaryLight,
      dark: BRAND.primaryDark,
      contrastText: "#ffffff",
    },
    info: {
      main: BRAND.primary,
      contrastText: "#ffffff",
    },
    success: { main: BRAND.success, contrastText: "#ffffff" },
    // Amber needs dark text; letting MUI choose gives white on amber (~3:1).
    warning: { main: BRAND.warning, contrastText: "rgba(0, 0, 0, 0.87)" },
    error: { main: BRAND.danger, contrastText: "#ffffff" },
    text: {
      primary: BRAND.textPrimary,
      secondary: BRAND.textSecondary,
    },
  },
  typography: {
    fontFamily: BRAND.fontFamily,
    button: { fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    // Most call sites already set this inline; making it the default keeps the
    // remaining buttons from shouting in uppercase.
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none" },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default theme;
